import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'


/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API */
import ExpenseTypesApi from 'api/setting/finances/expense-type.api'
/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  NOT_FOUND_EXPENSE_TYPE: ``,
  EXPENSE_TYPE_ALREADY_SYSTEM: ``,
  INVALID_CREATED: ``,
  INVALID_UPDATED: ``,
  IS_DUPLICATE_EXPENSE_TYPE_SHORTNAME: ``,
  IS_DUPLICATE_EXPENSE_TYPE_NAME: ``,

  EXPENSE_TYPE_NAME: ``,
  EXPENSE_TYPE_NAME_STRING_BASE: ``,
  EXPENSE_TYPE_NAME_STRING_EMPTY: ``,
  EXPENSE_TYPE_NAME_MAXIMUM_LENGTH: ``,
  EXPENSE_TYPE_NAME_ANY_REQUIRED: ``,
  EXPENSE_GROUP_STRING_VALID: ``,
  EXPENSE_GROUP_ANY_REQUIRED: ``
}
export default function ExpenseTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [expenseTypes, setExpenseTypes] = useState([])

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpen, setIsOpen] = useState(false)
  const [expenseTypeId, setExpenseTypeId] = useState(Number)
  const [expenseTypeName, setExpenseTypeName] = useState('')
  const [expenseGroup, setExpenseGroup] = useState<string>('INCOME')
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [expenseTypeStatus, setExpenseTypeStatus] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [type, setType] = useState('ALL')
  const loadData = async () => {
    try {
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (search) condition = { ...condition, search: search }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (type) condition = { ...condition, type: type === 'ALL' ? '' : type }

      const resp = await ExpenseTypesApi.findAll(condition)
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setExpenseTypes(resp.data)
      } else {
        setExpenseTypes([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const onActive = () => {
    if (id) {
      ExpenseTypesApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('EXPENSE_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('EXPENSE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      ExpenseTypesApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('EXPENSE_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('EXPENSE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    setExpenseTypeId(data.expenseTypeId)
    setExpenseTypeName(data.expenseTypeName)
    setExpenseGroup(data.expenseGroup)
    setExpenseTypeStatus(data.status)
    setIsOpen(true)
  }


  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setType(statusVal)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'expenseTypeName', disablePadding: false, label: t('EXPENSE_TYPE.TABLE.CELL.EXPENSE_TYPE_NAME') },
    { id: 'expenseGroup', disablePadding: false, label: t('EXPENSE_TYPE.TABLE.CELL.EXPENSE_GROUP') },
    { id: 'updatedBy', disablePadding: false, label: t('EXPENSE_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { expenseTypeId: epsTypeId, expenseTypeName: epsTypeName, expenseGroup: epsGroup, updatedBy, updatedAt } = objData
    const objRenderData = {
      key: epsTypeId,
      id: epsTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: epsTypeName },
        { option: 'TEXT', align: 'left', label: epsGroup === 'INCOME' ? t('EXPENSE_TYPE.MODAL.FORM.INCOME') : t('EXPENSE_TYPE.MODAL.FORM.EXPENSE') },

        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [

            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.expenseTypeName)
  }

  const resetForm = () => {
    setIsOpen(false)
    setExpenseTypeId(0)
    setExpenseTypeName('')
    setExpenseGroup('INCOME')
    setErrorMessage(initStateErrorMessage)
  }

  const submit = () => {
    if (!expenseTypeName) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_TYPE_NAME: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_TYPE_NAME`) } })
    if (!expenseGroup) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_GROUP: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_GROUP`) } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    ExpenseTypesApi.create({ expenseTypeName, expenseGroup })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t(`EXPENSE_TYPE.MESSAGE.SUCCESS.CREATE`), '', null, null)
          loadData()
          resetForm()
          setIsOpen(false)
        } else {
          const err = res?.response?.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e?.response?.data
        setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`EXPENSE_TYPE.MESSAGE.${err?.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!expenseTypeName) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_TYPE_NAME: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_TYPE_NAME`) } })
    if (!expenseGroup) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_GROUP: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_GROUP`) } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    ExpenseTypesApi.update(expenseTypeId, { expenseTypeName, expenseGroup, status: expenseTypeStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`EXPENSE_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          loadData()
          resetForm()
          setIsOpen(false)
        } else {
          const err = res?.response?.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e?.response?.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`EXPENSE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`EXPENSE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { expenseTypeName: name, status: t(`EXPENSE_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('EXPENSE_TYPE.TITLE')} />

      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('EXPENSE_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('EXPENSE_TYPE.TYPE.ALL') },
                { value: 'EXPENSE', name: t('EXPENSE_TYPE.TYPE.EXPENSE') },
                { value: 'INCOME', name: t('EXPENSE_TYPE.TYPE.INCOME') }
              ]}
              label={t('EXPENSE_TYPE.TYPE_SELECT')}
              value={type}
              width="100%"
            />
          </Grid>
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />
          </Grid>
          <Grid item xs={7} display="flex" justifyContent="flex-end">
            <MainButton
              title={t('EXPENSE_TYPE.BUTTON.ADD')}
              disabled={permissions.isCreate.disabled}
              type='primary'
              variant='contained'
              onClick={() => setIsOpen(true)}
              startIcon={<AddCircleIcon />}
            />
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={expenseTypes.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          isOpen={isOpen}
          title={expenseTypeId !== 0 ? t('EXPENSE_TYPE.TITLE_UPDATE') : t('EXPENSE_TYPE.TITLE_CREATE')}
          size='XS'
          handleClose={resetForm}
          onCancel={{ onClick: resetForm, title: t('EXPENSE_TYPE.BUTTON.CANCEL') }}
          onSubmit={{ onClick: expenseTypeId !== 0 ? submitEdit : submit, disabled: disabledSubmit }}
        >
          <Box gap="16px">
            <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
              <Typography fontSize="16px" fontWeight={400}>{t('EXPENSE_TYPE.MODAL.FORM.EXPENSE_TYPE')}</Typography>
              <RadioButton
                name='expense-type'
                onChange={(event) => setExpenseGroup(event.target.value)}
                options={[
                  { label: t('EXPENSE_TYPE.MODAL.FORM.INCOME'), value: 'INCOME', },
                  { label: t('EXPENSE_TYPE.MODAL.FORM.EXPENSE'), value: 'EXPENSE', }
                ]}
                defaultValue='INCOME'
                value={expenseGroup}
                row
              />
            </Box>
            <Box marginTop="16px">
              <TextInput
                onChange={(event) => {
                  setExpenseTypeName(event.target.value)
                  setErrorMessage(initStateErrorMessage)
                }}
                value={expenseTypeName}
                label={t('EXPENSE_TYPE.INPUT.EXPENSE_TYPE_NAME')}
                fullWidth
                required
                helperText={
                  errorMessage.EXPENSE_TYPE_NAME ||
                  errorMessage.IS_DUPLICATE_EXPENSE_TYPE_NAME ||
                  errorMessage.EXPENSE_TYPE_NAME_STRING_BASE ||
                  errorMessage.EXPENSE_TYPE_NAME_STRING_EMPTY ||
                  errorMessage.EXPENSE_TYPE_NAME_MAXIMUM_LENGTH ||
                  errorMessage.EXPENSE_TYPE_NAME_ANY_REQUIRED
                }
              />
            </Box>
          </Box>
        </PageModal>
      </Box>
    </Box>
  )
}

type ModalFormExpenseTypeProps = {
  loadData: () => void
  dataEdit?: any
  closeModal?: () => void
  afterSave?: (data: any) => void
  expenseGroup?: string
}

export const ModalFormExpenseType = (props: ModalFormExpenseTypeProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [expenseTypeId, setExpenseTypeId] = useState(Number)
  const [expenseTypeName, setExpenseTypeName] = useState('')
  const [expenseGroup, setExpenseGroup] = useState<string>(props?.expenseGroup || 'INCOME')
  const [expenseTypeStatus, setExpenseTypeStatus] = useState('')
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [isOpen, setIsOpen] = useState(false)

  const onEdit = () => {
    const {
      expenseTypeId: epsTypeId,
      expenseTypeName: epsTypeName,
      expenseGroup: epsGroup,
      status: epsStatus
    } = props.dataEdit

    setExpenseTypeId(epsTypeId)
    setExpenseTypeName(epsTypeName)
    setExpenseGroup(epsGroup)
    setExpenseTypeStatus(epsStatus)
  }

  useEffect(() => {
    if (props?.dataEdit) {
      onEdit()
    }
  }, [props?.dataEdit])

  useEffect(() => {
    if (props?.expenseGroup) {
      setExpenseGroup(props.expenseGroup)
    }
  }, [expenseGroup, props.expenseGroup])

  const submit = () => {
    if (!expenseTypeName) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_TYPE_NAME: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_TYPE_NAME`) } })
    if (!expenseGroup) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_GROUP: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_GROUP`) } })

    dispatch(submitModal())
    ExpenseTypesApi.create({ expenseTypeName, expenseGroup })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t(`EXPENSE_TYPE.MESSAGE.SUCCESS.CREATE`), '', null, null)
          props.loadData()
          if (props?.afterSave) {
            props.afterSave(res.data)
          }
          resetForm()
          dispatch(resetModal())
        } else {
          const err = res?.response?.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e?.response?.data
        setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`EXPENSE_TYPE.MESSAGE.${err?.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const submitEdit = () => {
    if (!expenseTypeName) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_TYPE_CODE: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_TYPE_NAME`) } })
    if (!expenseGroup) return setErrorMessage({ ...errorMessage, ...{ EXPENSE_TYPE_CODE: t(`EXPENSE_TYPE.MESSAGE.EXPENSE_GROUP`) } })

    dispatch(submitModal())
    ExpenseTypesApi.update(expenseTypeId, { expenseTypeName, expenseGroup, status: expenseTypeStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`EXPENSE_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          props.loadData()
          resetForm()
          dispatch(resetModal())
        } else {
          const err = res?.response?.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e?.response?.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`EXPENSE_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    if (props?.closeModal) props.closeModal()
    // dispatch(resetModal())
    setIsOpen(false)
    setExpenseTypeId(0)
    setExpenseTypeName('')
    setExpenseGroup('INCOME')
    clearErrorMessage()
  }

  const handleCheckBox = (status: 'INCOME' | 'EXPENSE') => {
    return status === props?.expenseGroup ? false : true
  }

  return (
    <PageModal
      isOpen={!!(expenseTypeId || props?.dataEdit || true)}
      title={expenseTypeId ? t('EXPENSE_TYPE.TITLE_UPDATE') : t('EXPENSE_TYPE.TITLE_CREATE')}
      size="XS"
      handleClose={resetForm}
      onCancel={{ onClick: resetForm, title: t('EXPENSE_TYPE.BUTTON.CANCEL') }}
      onSubmit={{
        onClick: expenseTypeId ? submitEdit : submit,
        title: expenseTypeId ? t('EXPENSE_TYPE.BUTTON.UPDATE') : t('EXPENSE_TYPE.BUTTON.SAVE')
      }}
    >
      <Box pb={2} display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography>{t('EXPENSE_TYPE.MODAL.FORM.EXPENSE_TYPE')}</Typography>
          <RadioButton
            name="expense-type"
            onChange={(event) => setExpenseGroup(event.target.value)}
            options={[
              { label: t('EXPENSE_TYPE.MODAL.FORM.INCOME'), value: 'INCOME', disabled: props?.expenseGroup ? handleCheckBox("INCOME") : false },
              { label: t('EXPENSE_TYPE.MODAL.FORM.EXPENSE'), value: 'EXPENSE', disabled: props?.expenseGroup ? handleCheckBox("EXPENSE") : false }
            ]}
            value={expenseGroup}
            row
          />
        </Box>
        <Box>
          <TextInput
            onChange={(event) => {
              setExpenseTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={expenseTypeName}
            label={t('EXPENSE_TYPE.INPUT.EXPENSE_TYPE_NAME')}
            fullWidth
            required
            helperText={
              errorMessage.EXPENSE_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_EXPENSE_TYPE_NAME ||
              errorMessage.EXPENSE_TYPE_NAME_STRING_BASE ||
              errorMessage.EXPENSE_TYPE_NAME_STRING_EMPTY ||
              errorMessage.EXPENSE_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.EXPENSE_TYPE_NAME_ANY_REQUIRED
            }
          />
        </Box>
      </Box>
    </PageModal>
  )
}
